<script>
  import { onMount } from "svelte";
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  var videoEl;

onMount(async () => {
   

    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoEl.srcObject = stream;
      videoEl.play();

    var videoComponent = document.getElementById('webcameraPreview');
        //HTML select component for cameras change
        var webcameraChanger = document.getElementById('webcameraChanger');
        var options = {};
        //init options for scanner
        options = initVideoObjectOptions("webcameraPreview");
        var cameraId = 0;

        initScanner(options);

        initAvaliableCameras(
            webcameraChanger,
            function () {
                cameraId = parseInt(getSelectedCamera(webcameraChanger));
            }
        );

        initCamera(cameraId);


        scanStart(function (data){
          dispatch('scan', { data: data});
        });
  });
</script>



<video id="webcameraPreview" bind:this={videoEl} playsinline autoplay  muted loop style="width: 40vw;"></video>
<div class="frm-grp txt-cntr" style="display:none;">
  <p class="disp-blck">Choose camera:</p>
  <select id="webcameraChanger" onchange="cameraChange($(this).val());" class="frm-ctrl mar-btm-2"></select>
</div>
<style>
  #webcameraPreview{
    border-radius: 20px;
  }
</style>